import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { collection, query, getDocs, addDoc, where } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import AddTariffsModal from './AddTariffsModal';
import styles from './CustomerTariffsModal.module.css';

const CustomerTariffsModal = ({ isOpen, onClose, selectedCustomer }) => {
  const [tariffs, setTariffs] = useState([]);
  const [customerTariffs, setCustomerTariffs] = useState([]);
  const [showAddTariffModal, setShowAddTariffModal] = useState(false);

  // Fetch all available tariffs
  const fetchTariffs = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'Tariffs'));
      const tariffsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTariffs(tariffsData);
    } catch (error) {
      console.error('Error fetching tariffs:', error);
      toast.error('Tarifeler yüklenirken bir hata oluştu');
    }
  };

  // Fetch customer's assigned tariffs
  const fetchCustomerTariffs = async () => {
    try {
      const q = query(
        collection(db, 'CustomerTariffs'),
        where('customerId', '==', selectedCustomer.id)
      );
      const querySnapshot = await getDocs(q);
      const customerTariffsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCustomerTariffs(customerTariffsData);
    } catch (error) {
      console.error('Error fetching customer tariffs:', error);
      toast.error('Müşteri tarifeleri yüklenirken bir hata oluştu');
    }
  };

  useEffect(() => {
    fetchTariffs();
    fetchCustomerTariffs();
  }, [selectedCustomer.id]);

  const handleAssignTariff = async (tariff) => {
    try {
      await addDoc(collection(db, 'CustomerTariffs'), {
        customerId: selectedCustomer.id,
        tariffId: tariff.id,
        assignedAt: new Date().toISOString(),
        ...tariff
      });
      toast.success('Tarife müşteriye başarıyla atandı');
      fetchCustomerTariffs();
    } catch (error) {
      console.error('Error assigning tariff:', error);
      toast.error('Tarife atanırken bir hata oluştu');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
  };

  return (
    <div className={styles.modalBackdrop} style={{ display: isOpen ? 'flex' : 'none' }}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>Müşteri Tarifeleri - {selectedCustomer.Başlık}</h2>
        </div>

        <div className={styles.content}>
          {/* <div className={styles.sectionHeader}>
            <h3 className={styles.sectionTitle}>Mevcut Tarifeler</h3>
            <button className={styles.addButton} onClick={() => setShowAddTariffModal(true)}>
              Yeni Tarife Ekle
            </button>
          </div> */}

          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Tarife Tipi</th>
                  <th>Tarife Değer</th>
                  <th>Fiyat</th>
                  <th>Döviz Tipi</th>
                  <th>Tarih</th>
                  <th>Subcontractor</th>
                  <th>Bilgi</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {tariffs.map((tariff) => (
                  <tr key={tariff.id}>
                    <td>{tariff.type}</td>
                    <td>{tariff.value}</td>
                    <td>{tariff.price}</td>
                    <td>{tariff.currency}</td>
                    <td>{formatDate(tariff.date)}</td>
                    <td>{tariff.isSubcontractor}</td>
                    <td>{tariff.info}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleAssignTariff(tariff)}
                        disabled={customerTariffs.some(ct => ct.tariffId === tariff.id)}
                      >
                        {customerTariffs.some(ct => ct.tariffId === tariff.id)
                          ? 'Atanmış'
                          : 'Ata'}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h3 className={styles.sectionTitle}>Müşteriye Atanmış Tarifeler</h3>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Tarife Tipi</th>
                  <th>Tarife Değer</th>
                  <th>Fiyat</th>
                  <th>Döviz Tipi</th>
                  <th>Tarih</th>
                  <th>Subcontractor</th>
                  <th>Bilgi</th>
                  <th>Atanma Tarihi</th>
                </tr>
              </thead>
              <tbody>
                {customerTariffs.map((tariff) => (
                  <tr key={tariff.id}>
                    <td>{tariff.type}</td>
                    <td>{tariff.value}</td>
                    <td>{tariff.price}</td>
                    <td>{tariff.currency}</td>
                    <td>{formatDate(tariff.date)}</td>
                    <td>{tariff.isSubcontractor}</td>
                    <td>{tariff.info}</td>
                    <td>{formatDate(tariff.assignedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.closeButton} onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>

      <AddTariffsModal
        show={showAddTariffModal}
        handleClose={() => {
          setShowAddTariffModal(false);
          fetchTariffs();
        }}
      />
    </div>
  );
};

export default CustomerTariffsModal;